import React from 'react';
import SalesInvoiceForm from './SalesInvoiceForm'; // Adjust path
import { useParams } from 'react-router-dom';

const EditSalesInvoicePage = () => {
    const { id } = useParams(); // Get ID from URL
    
    // Renders the form in 'edit' mode (which will be read-only)
    return id ? <SalesInvoiceForm formType="edit" currentInvoiceId={id} /> : <div>Loading...</div>;
};

export default EditSalesInvoicePage;